export const Twelve = 'l';